module.exports = __webpack_public_path__ + "img/inTransit.c06f94be.svg";